import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.imageAddressColor,
    border: `1px solid ${theme.KPI.KPIDivider}`,
    color: theme.iconColor,
    margin: '12 0 8 0',
    padding: 12,
    borderRadius: '4px'
  },
  detailsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: theme.textFontSize
  },
  detailsSubContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  title: {
    fontWeight: 500,
    fontSize: theme.dispatchCardTextFontSize,
    textTransform: 'uppercase',
    lineHeight: '16px',
    marginBottom: 6
  },
  label: {
    fontWeight: 400
  },
  value: {
    color: theme.TextColor,
    fontWeight: 600
  }
});

const Details = ({ label, value, classes }) => {
  return (
    <div className={classes.detailsSubContainer}>
      <span className={classes.label}>{label}</span>
      <span className={classes.value}>{value}</span>
    </div>
  );
};

const formatDriver = (driverName, driverNumber) => {
  //if shipment is a part of a closed trailer route and route is not yet dispatched, then these fields can be null
  return driverNumber ? `${driverName} (#${driverNumber})` : '';
};

const ManifestProDetails = ({
  manifestNumber,
  trailerNumber,
  driverNumber = '',
  driverName = '',
  proAlreadyInManifest = null,
  classes
}) => {
  return (
    <div className={classes.container}>
      <span className={classes.title}>
        {proAlreadyInManifest
          ? 'Pro is already part of the same manifest'
          : 'Pro already part of the manifest'}
      </span>
      <div className={classes.detailsContainer}>
        <Details label="Manifest #" value={manifestNumber} classes={classes} />
        <Details label="Trailer #" value={trailerNumber} classes={classes} />
        <Details label="Driver" value={formatDriver(driverName, driverNumber)} classes={classes} />
      </div>
    </div>
  );
};

export default withStyles(styles)(ManifestProDetails);
